// Implements: F-IDN-012
/**
 * Saving the own name (`PATCH /auth/me`). The answer is the new profile, written straight into the
 * cache; the session bootstrap is invalidated too, because the user menu and the shell read the
 * name from `GET /auth/me/scopes` and must show the new one without a reload.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { SESSION_SCOPES_KEY } from "../../../shared/api/queryKeys";
import type { MeSummary } from "../../../types/api";
import { ACCOUNT_ME_KEY, updateProfile } from "../api/accountApi";

export function useUpdateProfile(): UseMutationResult<MeSummary, ApiError, string> {
  const client = useQueryClient();
  return useMutation<MeSummary, ApiError, string>({
    mutationFn: updateProfile,
    onSuccess: async (me) => {
      client.setQueryData(ACCOUNT_ME_KEY, me);
      await Promise.all([
        client.invalidateQueries({ queryKey: ACCOUNT_ME_KEY }),
        client.invalidateQueries({ queryKey: SESSION_SCOPES_KEY }),
      ]);
    },
  });
}
